import { useEffect, useState } from "react";
import CountUp from "react-countup";
import axios from "axios";
import { useOutletContext } from "react-router-dom";
import { currency_converter_inr, currency_converter_selected } from "../../../utils/currencyUtils";
import { openInAppTab } from "../../../utils/tabNavigation";
import ByGeography from "./components/ByGeography";
import ByIndustry from "./components/ByIndustry";
import ByFunction from "./components/ByFunction";

function Overview(){
  const { selectedUser, year, setGlobalLoading, token } = useOutletContext();
  const [data,setData] = useState([]);
  const REACT_APP_API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  let user = {};
  let currencies = [];
  user = JSON.parse(localStorage.getItem("user") || "{}");
  currencies = JSON.parse(localStorage.getItem("currency_rates") || "[]");
  const defaultCurrencyId = Number(user?.default_currency_id || 1);
  const selectedCurrency = currencies.find((currency) => Number(currency.value) === defaultCurrencyId);
  const symbol = selectedCurrency?.symbol || (defaultCurrencyId === 1 ? "₹" : "");
  const amountSuffix = defaultCurrencyId === 1 ? "Cr" : "M";
  const amountDivisor = defaultCurrencyId === 1 ? 10000000 : 1000000;


  function getGrowthPercent({ current, previous }) {
    const growth =
        previous === 0 && current > 0
        ? "100"
        : previous === 0 && current === 0
        ? "0.00"
        : (((current - previous) / previous) * 100).toFixed(2);

    return growth;
  }
  const getCurrentFY = () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = today.getMonth() + 1; // Jan = 1

    // If before April → still previous FY
    if (month < 4) {
        return `${year - 1} - ${year}`;
    } else {
        return `${year} - ${year + 1}`;
    }
    };

  function RevenueCounter({ value, format = true }) {
        const safeValue = Number(value) || 0;
        return (
            <CountUp
                start={0}
                end={safeValue}
                duration={1}
                formattingFn={format ? currency_converter_selected : undefined}
            />
        );
  }

//   const formatRevenueInCr = (value) => {
//     const cr = Number(value || 0) / 10000000;
//     return `₹${Number(cr.toFixed(2))} Cr`;
//     };  

    const formatRevenueInCr = (value) => {
        const amount = Number(value || 0);
        const convertedAmount = amount / amountDivisor;
        return `${symbol}${Number(convertedAmount.toFixed(2))} ${amountSuffix}`;
    };

  useEffect(()=>{
    if(!selectedUser) return;
    let isLatest = true; 
    const getOverview = async ()=>{
    try{
    setGlobalLoading(true);    
    
    const currentFY = getCurrentFY();
    const isCurrentFY = year === currentFY;
    const url = isCurrentFY
    ? `${REACT_APP_API_BASE_URL}/performance/overview`
    : `${REACT_APP_API_BASE_URL}/performance/overviewPastYear`;

    const response = await axios.get(url, {
    params: { user_id: selectedUser.id, year: year },
    headers: { Authorization: `Bearer ${token}` },
    });

    // const response = await axios.get(`${REACT_APP_API_BASE_URL}/performance/overview`,
    //  {
    //     params:{ user_id:selectedUser.id, year:year },
    //     headers: { Authorization: `Bearer ${token}` },
    //  }
    // );
     if (!isLatest) return;
    const d = response.data;
    console.log("overview response", response.data);
    if(response.status === 200) {
        const current_bd_revenue = d?.revenue_bd_current_year?.[0]?.total_revenue || 0;
        const prev_bd_revenue = d?.revenue_bd_previous_year?.[0]?.total_revenue || 0; 
        const revenue_bd_growth = getGrowthPercent({current: current_bd_revenue, previous: prev_bd_revenue});
        const current_revenue = d?.revenue_current_year?.[0]?.total_revenue || 0;
        const prev_revenue =  d?.revenue_prev_year?.[0]?.sum || 0;
        const revenue_growth = getGrowthPercent({current: current_revenue, previous: prev_revenue});
        const shared_delivery = d?.revenue_current_year?.[0]?.total_revenue - d?.self_bd_delivered[0]?.total_revenue;
        const other_partner_delivered =  d?.revenue_bd_current_year?.[0]?.total_revenue - d?.self_bd_delivered[0]?.total_revenue;
        const shared_delivery_percentage = ((shared_delivery / current_revenue) * 100).toFixed(2);
        const prev_avg_vobt = d?.prev_year_average_vobt?.[0]?.avg_vobt;
        const avg_growth_vobt = ((((d?.average_vobt?.[0]?.avg_vobt || 0) - (prev_avg_vobt || 0)) / (prev_avg_vobt || 1)) * 100).toFixed(2);
        const prev_avg_arpa = d?.prev_year_arpa?.[0]?.avg_arpa;
        const avg_growth_arpa = ((((d?.curr_year_arpa?.[0]?.avg_arpa || 0) - (prev_avg_arpa || 0)) / (prev_avg_arpa || 1)) * 100).toFixed(2);
        const avg_fee_percentage = (((d?.revenue_current_year?.[0]?.totalFees || 0) / (d?.revenue_current_year?.[0]?.billableAmount || 1)) * 100).toFixed(2);
        const prev_avg_fee_percentage = (((d?.revenue_prev_year?.[0]?.totalFees || 0) / (d?.revenue_prev_year?.[0]?.billableAmount || 1)) * 100).toFixed(2);
        
        const avg_fee_growth = prev_avg_fee_percentage ? (((avg_fee_percentage - prev_avg_fee_percentage) / prev_avg_fee_percentage) * 100).toFixed(2) : "0.00";
        const avgHighRiskScoreFinal = d?.avgHighRiskScore !== null && d?.avgHighRiskScore !== undefined ? Number(d.avgHighRiskScore || 0).toFixed(2) : "--";
        const revenueData = d?.revenue_current_year?.[0] || {};
        const collection = Number(revenueData.collection_revenue) || 0;
        const total = Number(revenueData.total_revenue) || 0;
        let collection_efficiency = "0.00";
        if (total > 0) { collection_efficiency = ((collection / total) * 100).toFixed(2);}
        const revenueTarget = Number(d?.revenue_target?.[0]?.target || 0);
        const revenueBDTarget = Number(d?.revenue_target?.[0]?.bd_target || 0);
        const closedTarget = d?.revenue_target?.[0]?.closed_target || 0;
        const revenueBDAchievement = revenueBDTarget > 0 ? (current_bd_revenue / revenueBDTarget) * 100 : 0;
        const revenueAchievement = revenueTarget > 0 ? (current_revenue / revenueTarget) * 100 : 0;
        
        const revenueNetAdd = d?.revnue_netadd?.[0]?.current_year_net_add || 0;
        const revenueNetAddPrevoius = d?.revnue_netadd?.[0]?.last_year_net_add || 0;
        const revenue_netadd_growth = getGrowthPercent({current: revenueNetAdd, previous: revenueNetAddPrevoius});
       
        setData({
          ...d,
          revenue_bd_growth,
          revenue_growth,
          shared_delivery,
          other_partner_delivered,
          shared_delivery_percentage,
          avg_fee_percentage,
          avg_fee_growth,
          avg_growth_vobt,
          avg_growth_arpa,
          collection_efficiency,
          avgHighRiskScoreFinal,
          prev_bd_revenue,
          prev_revenue,
          prev_avg_fee_percentage,
          prev_avg_arpa,
          prev_avg_vobt,
          revenueTarget,
          revenueBDTarget,
          closedTarget,
          revenueBDAchievement ,
          revenueAchievement,
          revenueNetAdd,
          revenueNetAddPrevoius,
          revenue_netadd_growth 
        });
    }

    }catch (error) {
        console.log(error);
        setGlobalLoading(false);
      } finally {
        setGlobalLoading(false);
      }
    };
    getOverview();
     return () => {
        isLatest = false; // cancel old request
    };
    },[selectedUser,year]);

  const closerCount = [11, 12, 14].includes(Number(selectedUser?.id))
  ? data?.revenue_bd_current_year?.[0]?.closer_count
  : data?.revenue_current_year?.[0]?.closer_count;

  const closerCountPrevious = [11, 12, 14].includes(Number(selectedUser?.id))
  ? data?.revenue_bd_previous_year?.[0]?.closer_count
  : data?.revenue_prev_year?.[0]?.closer_count;
  
  const closures_percentage = closerCountPrevious ? (((closerCount - closerCountPrevious) / closerCountPrevious) * 100).toFixed(2) : "0.00";
        
   return (
    <>
    <div className="card">
        <div className="card-body">
            <div className="border-bottom mb-3 pb-3">
                <h4>Overview</h4>
                <p className="text-muted fs-13 mb-1">Business & delivery health at a glance</p>
            </div>
            <div className="d-flex align-items-center flex-wrap row-gap-2 mb-2">
                    <i className="ti ti-trending-up fs-18 text-primary me-2"></i>
                    <h5>BD Snapshot</h5>
            </div>

            <div className="row">
            <div className="col-xxl-3 col-xl-3 col-md-6 d-flex cursor-pointer" 
            onClick={() => { const formattedYear = year?.replace(/\s/g, "");
                openInAppTab(
                  `/order/business?user_id=${selectedUser?.id}&firstname=${selectedUser?.firstname}&lastname=${selectedUser?.lastname}&year=${formattedYear}`,
                );
                }}
                >
                <div className="card flex-fill cursor-pointer">
                <div className="card-body my-card-body">
                    <div className="d-flex align-items-center justify-content-between">
                    <div className="d-flex align-items-center">
                      <div>
                        <p className="fs-12 fw-medium mb-0 text-gray-5 mb-1">
                            Business Generated (YTD)
                        </p>
                        <h3 className="counter"><RevenueCounter value={Number(data?.revenue_bd_current_year?.[0]?.total_revenue || 0)} /></h3>
                        
                        <div className="d-flex align-items-center">
                            <span className="fw-10">
                                Last Year:{" "}
                                {currency_converter_selected(data?.prev_bd_revenue || 0)}
                            </span>
                        </div>
                        <div className={`fs-12 fw-medium col-md-12 col-sm-12 d-flex ${ data?.revenue_bd_growth > 0 ? "text-success" : "text-danger"}`}>
                        <i className={`fa-solid me-1 ${data?.revenue_bd_growth > 0 ? "fa-arrow-trend-up" : "fa-arrow-trend-down"}`}></i>{" "}
                        {data?.revenue_bd_growth}% <span className="fs-12 fw-medium mb-0 text-gray-5 mb-1 ms-1"> vs last year</span>
                        </div> 
                        <div>
                             <p className="fs-12 fw-medium mb-0 text-gray-5 mb-1">
                                Target: {" "}
                                <b>{formatRevenueInCr(data?.revenueBDTarget || 0)}</b>
                                {" ("}{Number(data?.revenueBDAchievement || 0).toFixed(1)}{"% Achieved)"}
                             </p>
                        </div>
                      </div>
                    </div>
                    </div>
                </div>
                </div>
            </div>
            <div className="col-xxl-3 col-xl-3 col-md-6 d-flex cursor-pointer" 
            onClick={() => { const formattedYear = year?.replace(/\s/g, "");
                openInAppTab(
                  `/order/revenue?user_id=${selectedUser?.id}&firstname=${selectedUser?.firstname}&lastname=${selectedUser?.lastname}&year=${formattedYear}`,
                );
                }}
                >
                <div className="card flex-fill cursor-pointer">
                <div className="card-body my-card-body">
                    <div className="d-flex align-items-center justify-content-between">
                    <div className="d-flex align-items-center">
                      <div>
                        <p className="fs-12 fw-medium mb-0 text-gray-5 mb-1">
                            Business Delivered
                        </p>
                        <h3 className="counter" style={{ color: "#06B4A0" }}>
                            <RevenueCounter value={Number(data?.revenue_current_year?.[0]?.total_revenue || 0)}/>
                        </h3>
                        <div className="d-flex align-items-center">
                            <span className="fw-10">
                                Last Year:{" "}
                                {currency_converter_selected(data?.prev_revenue || 0)}
                            </span>
                        </div>
                        <div className={`fs-12 fw-medium col-md-12 col-sm-12 d-flex ${ data?.revenue_growth > 0 ? "text-success" : "text-danger"}`}>
                        <i className={`fa-solid me-1 ${data?.revenue_growth > 0 ? "fa-arrow-trend-up" : "fa-arrow-trend-down"}`}></i>{" "}
                        {data?.revenue_growth}% <span className="fs-12 fw-medium mb-0 text-gray-5 mb-1 ms-1"> vs last year</span>
                        </div>
                        <div>
                            <p className="fs-12 fw-medium mb-0 text-gray-5 mb-1">
                                Target: {" "}
                                <b>{formatRevenueInCr(data?.revenueTarget || 0)}</b>
                                {" ("}{Number(data?.revenueAchievement || 0).toFixed(1)}{"% Achieved)"}
                            </p>
                        </div>
                      </div>
                    </div>
                    </div>
                </div>
                </div>
            </div>
            <div className="col-xxl-3 col-xl-3 col-md-6 d-flex">
                <div className="card flex-fill cursor-pointer">
                <div className="card-body my-card-body">
                    <div className="d-flex align-items-center justify-content-between">
                    <div className="d-flex align-items-center">
                        <div>
                        <p className="fs-12 fw-medium mb-0 text-gray-5 mb-1">
                            Referred Business
                        </p>
                        <h3 className="counter"><RevenueCounter value={Number(data?.shared_delivery || 0)}/></h3>
                        <p className="fs-12 fw-medium text-gray-5 mb-1 mt-3">
                            Shared Delivery %
                        </p>
                        <h3 className="counter"><RevenueCounter value={Number(data?.shared_delivery_percentage || 0)} format={false}/>%</h3>
                        </div>
                    </div>
                    </div>
                </div>
                </div>
            </div>
            <div className="col-xxl-3 col-xl-3 col-md-6 d-flex">
                <div className="card flex-fill cursor-pointer">
                <div className="card-body my-card-body">
                    <div className="d-flex align-items-center justify-content-between">
                    <div className="d-flex align-items-center">
                        <div>
                        <p className="fs-12 fw-medium mb-0 text-gray-5 mb-1">
                            Other Partner Delivered
                        </p>
                        <h3 className="counter"><RevenueCounter value={Number(data?.other_partner_delivered || 0)}/></h3>
                        <p className="fs-12 fw-medium mb-0 text-gray-5 mb-1">
                            
                        </p>
                        </div>
                    </div>
                    </div>
                </div>
                </div>
            </div>
            <div className="col-xxl-3 col-xl-3 col-md-6 d-flex">
                <div className="card flex-fill cursor-pointer">
                <div className="card-body my-card-body">
                    <div className="d-flex align-items-center justify-content-between">
                    <div className="d-flex align-items-center">
                        <div>
                        <p className="fs-12 fw-medium mb-0 text-gray-5 mb-1">
                            Net-Add
                        </p>
                        <h3 className="counter"><RevenueCounter value={data?.revenueNetAdd || 0}/></h3>
                        <div className="d-flex align-items-center">
                            <span className="fw-10">
                                Last Year:{" "}{currency_converter_selected(data?.revenueNetAddPrevoius || 0)}
                            </span>
                        </div>
                        <div className={`fs-12 fw-medium col-md-12 col-sm-12 d-flex ${ data?.revenue_netadd_growth > 0 ? "text-success" : "text-danger"}`}>
                            <i className={`fa-solid me-1 ${data?.revenue_netadd_growth > 0 ? "fa-arrow-trend-up" : "fa-arrow-trend-down"}`}></i>{" "}
                            {data?.revenue_netadd_growth}% <span className="fs-12 fw-medium mb-0 text-gray-5 mb-1 ms-1"> vs last year</span>
                        </div>
                        </div>
                    </div>
                    </div>
                </div>
                </div>
            </div>
            <div className="col-xxl-3 col-xl-3 col-md-6 d-flex">
                <div className="card flex-fill cursor-pointer">
                <div className="card-body my-card-body">
                    <div className="d-flex align-items-center justify-content-between">
                    <div className="d-flex align-items-center">
                        <div>
                        <p className="fs-12 fw-medium mb-0 text-gray-5 mb-1">
                            Closures Count
                        </p>
                        <h3 className="counter" style={{ color: "#06B4A0" }}>
                           <RevenueCounter value={Number(closerCount || 0)}  format={false}/>
                        </h3>
                        <div className="d-flex align-items-center">
                            <span className="fw-10">
                                Last Year:{" "} {Number(closerCountPrevious || 0)}
                            </span>
                        </div>
                        <p className="fs-12 fw-medium mb-0 text-gray-5 mb-1">
                        <div className={`fs-12 fw-medium col-md-12 col-sm-12 d-flex ${ closures_percentage > 0 ? "text-success" : "text-danger"}`}>
                        <i className={`fa-solid me-1 ${closures_percentage > 0 ? "fa-arrow-trend-up" : "fa-arrow-trend-down"}`}></i>{" "}
                        {closures_percentage || 0}% <span className="fs-12 fw-medium mb-0 text-gray-5 mb-1 ms-1"> vs last year</span>
                        </div>
                        </p>
                        </div>
                    </div>
                    </div>
                </div>
                </div>
            </div>
            <div className="col-xxl-3 col-xl-3 col-md-6 d-flex">
                <div className="card flex-fill cursor-pointer">
                <div className="card-body my-card-body">
                    <div className="d-flex align-items-center justify-content-between">
                    <div className="d-flex align-items-center">
                        <div>
                        <p className="fs-12 fw-medium mb-0 text-gray-5 mb-1">
                            Avg Fee %
                        </p>
                        <h3 className="counter"><RevenueCounter value={Number(data?.avg_fee_percentage || 0)} format={false}/>%</h3>
                        <p className="fs-12 fw-medium mb-0 text-gray-5 mb-1">
                        <div className="d-flex align-items-center">
                            <span className="fw-10">
                                Last Year:{" "}
                                {data?.prev_avg_fee_percentage || 0}%
                            </span>
                        </div>    
                        <div className={`fs-12 fw-medium col-md-12 col-sm-12 d-flex ${ data?.avg_fee_growth > 0 ? "text-success" : "text-danger"}`}>
                        <i className={`fa-solid me-1 ${data?.avg_fee_growth > 0 ? "fa-arrow-trend-up" : "fa-arrow-trend-down"}`}></i>{" "}
                        {data?.avg_fee_growth}% <span className="fs-12 fw-medium mb-0 text-gray-5 mb-1 ms-1"> vs last year</span>
                        </div>    
                        </p>
                        </div>
                    </div>
                    </div>
                </div>
                </div>
            </div>
            <div className="col-xxl-3 col-xl-3 col-md-6 d-flex">
                <div className="card flex-fill cursor-pointer">
                <div className="card-body my-card-body">
                    <div className="d-flex align-items-center justify-content-between">
                    <div className="d-flex align-items-center">
                        <div>
                        <p className="fs-12 fw-medium mb-0 text-gray-5 mb-1">
                            ARPA
                        </p>
                        <h3 className="counter"><RevenueCounter value={Number(data?.curr_year_arpa?.[0]?.avg_arpa || 0)}/></h3>
                        <div className="d-flex align-items-center">
                            <span className="fw-10">
                                Last Year:{" "}
                                {currency_converter_selected(data?.prev_avg_arpa || 0)}
                            </span>
                        </div>
                        <div className={`fs-12 fw-medium col-md-12 col-sm-12 d-flex ${ data?.avg_growth_arpa > 0 ? "text-success" : "text-danger"}`}>
                        <i className={`fa-solid me-1 ${data?.avg_growth_arpa > 0 ? "fa-arrow-trend-up" : "fa-arrow-trend-down"}`}></i>{" "}
                        {data?.avg_growth_arpa}% <span className="fs-12 fw-medium mb-0 text-gray-5 mb-1 ms-1"> vs last year</span>
                        </div>
                        </div>
                    </div>
                    </div>
                </div>
                </div>
            </div>
            <div className="col-xxl-3 col-xl-3 col-md-6 d-flex">
                <div className="card flex-fill cursor-pointer">
                <div className="card-body my-card-body">
                    <div className="d-flex align-items-center justify-content-between">
                    <div className="d-flex align-items-center">
                        <div>
                        <p className="fs-12 fw-medium mb-0 text-gray-5 mb-1">
                            Avg VOBT
                        </p>
                        <h3 className="counter"><RevenueCounter value={Number(data?.average_vobt?.[0]?.avg_vobt || 0)}/></h3>
                        <div className="d-flex align-items-center">
                            <span className="fw-10">
                                Last Year:{" "}
                                {currency_converter_selected(data?.prev_avg_vobt || 0)}
                            </span>
                        </div>
                        <div className={`fs-12 fw-medium col-md-12 col-sm-12 d-flex ${ data?.avg_growth_vobt > 0 ? "text-success" : "text-danger"}`}>
                        <i className={`fa-solid me-1 ${data?.avg_growth_vobt > 0 ? "fa-arrow-trend-up" : "fa-arrow-trend-down"}`}></i>{" "}
                        {data?.avg_growth_vobt}% <span className="fs-12 fw-medium mb-0 text-gray-5 mb-1 ms-1"> vs last year</span>
                        </div>
                        </div>
                    </div>
                    </div>
                </div>
                </div>
            </div>
            <div className="col-xxl-3 col-xl-3 col-md-6 d-flex">
                <div className="card flex-fill cursor-pointer">
                <div className="card-body my-card-body">
                    <div className="d-flex align-items-center justify-content-between">
                    <div className="d-flex align-items-center">
                        <div>
                        <p className="fs-12 fw-medium mb-0 text-gray-5 mb-1">
                            Cross-Border Searches
                        </p>
                        <h3 className="counter"><RevenueCounter value={Number(data?.cross_border?.[0]?.sum || 0)} format={false}/></h3>
                        </div>
                    </div>
                    </div>
                </div>
                </div>
            </div>
            <div className="col-xxl-3 col-xl-3 col-md-6 d-flex">
                <div className="card flex-fill cursor-pointer">
                <div className="card-body my-card-body">
                    <div className="d-flex align-items-center justify-content-between">
                    <div className="d-flex align-items-center">
                        <div>
                        <p className="fs-12 fw-medium mb-0 text-gray-5 mb-1">
                            Largest Search Closed
                        </p>
                        <h3 className="counter" style={{ color: "#06B4A0" }}><RevenueCounter value={Number(data?.largest_search_fee?.[0]?.fee_amount || 0)}/></h3>
                        <p className="fs-12 fw-medium mb-0 text-gray-5 mb-1">
                            {data?.largest_search_fee?.[0]?.candidate_name} 
                        </p>
                        <p className="fs-10 fw-medium mb-0 text-gray-5 mb-1">
                            {data?.largest_search_fee?.[0]?.company_name} - {data?.largest_search_fee?.[0]?.role_name}
                        </p>
                        </div>
                    </div>
                    </div>
                </div>
                </div>
            </div>
            <div className="col-xxl-3 col-xl-3 col-md-6 d-flex">
                <div className="card flex-fill cursor-pointer">
                <div className="card-body my-card-body">
                    <div className="d-flex align-items-center justify-content-between">
                    <div className="d-flex align-items-center">
                        <div>
                        <p className="fs-12 fw-medium mb-0 text-gray-5 mb-1">
                            Largest Compensation
                        </p>
                        <h3 className="counter" style={{ color: "#06B4A0" }}><RevenueCounter value={Number(data?.largest_search_compensation?.[0]?.total_compensation_amount || 0)}/></h3>
                        <p className="fs-12 fw-medium mb-0 text-gray-5 mb-1">
                            {data?.largest_search_compensation?.[0]?.candidate_name} 
                        </p>
                        <p className="fs-10 fw-medium mb-0 text-gray-5 mb-1">
                            {data?.largest_search_compensation?.[0]?.company_name} - {data?.largest_search_compensation?.[0]?.role_name}
                        </p>
                        </div>
                    </div>
                    </div>
                </div>
                </div>
            </div>
            </div>

            <div className="d-flex align-items-center flex-wrap row-gap-2 mb-2">
                    <i className="ti ti-globe fs-18 text-warning me-2"></i>
                    <h5>Work Mix</h5>
            </div>
            <div className="row">
                <div className="card">
                    <div className="card-body">
                        <div className="row">
                            <div className="col-xxl-4 col-xl-4 col-md-6 d-flex">
                                <div className="card flex-fill cursor-pointer">
                                <div className="card-body my-card-body">
                                    <div className="d-flex align-items-center justify-content-between">
                                    <div className="d-flex align-items-center">
                                    <div>
                                        <p className="fs-12 fw-medium mb-0 text-gray-5 mb-1">Geographies</p>
                                            <ByGeography chart_data={data?.revenue_geography} />
                                    </div>
                                    </div>
                                    </div>
                                </div>
                                </div>
                            </div>
                            <div className="col-xxl-4 col-xl-4 col-md-6 d-flex">
                                <div className="card flex-fill cursor-pointer">
                                <div className="card-body my-card-body">
                                    <div className="d-flex align-items-center justify-content-between">
                                    <div className="d-flex align-items-center">
                                    <div>
                                        <p className="fs-12 fw-medium mb-0 text-gray-5 mb-1">Sectors</p>
                                            <ByIndustry chart_data={data?.revenue_industry} />
                                    </div>
                                    </div>
                                    </div>
                                </div>
                                </div>
                            </div>
                            <div className="col-xxl-4 col-xl-4 col-md-6 d-flex">
                                <div className="card flex-fill cursor-pointer">
                                <div className="card-body my-card-body">
                                    <div className="d-flex align-items-center justify-content-between">
                                    <div className="d-flex align-items-center">
                                    <div>
                                        <p className="fs-12 fw-medium mb-0 text-gray-5 mb-1">Level</p>
                                            <ByFunction chart_data={data?.revenue_rolelevels} />
                                    </div>
                                    </div>
                                    </div>
                                </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="d-flex align-items-center flex-wrap row-gap-2 mb-2">
                    <i className="fa-solid fa-triangle-exclamation fs-18 text-danger me-2"></i>
                    <h5>Risk Snapshot</h5>
            </div>
            <div className="row">
                <div className="col-xl-3 col-md-6 d-flex">
                    <div className="card flex-fill cursor-pointer">
                    <div className="card-body my-card-body">
                        <div className="d-flex align-items-center justify-content-between">
                        <div className="d-flex align-items-center">
                          <div>
                            <p className="fs-12 fw-medium mb-0 text-gray-5 mb-1">Avg Role Risk Score</p>
                            <h3 className="counter"> {data?.avgHighRiskScoreFinal ?? "--"}</h3>    
                          </div>
                        </div>
                        </div>
                    </div>
                    </div>
                </div>
                <div className="col-xl-3 col-md-6 d-flex">
                    <div className="card flex-fill cursor-pointer">
                    <div className="card-body my-card-body">
                        <div className="d-flex align-items-center justify-content-between">
                        <div className="d-flex align-items-center">
                          <div>
                            <p className="fs-12 fw-medium mb-0 text-gray-5 mb-1">High-Risk Client</p>
                            <h3 className="counter">{data?.client_atrisk?.[0]?.total_companies || 0}</h3>    
                          </div>
                        </div>
                        </div>
                    </div>
                    </div>
                </div>
                <div className="col-xl-3 col-md-6 d-flex">
                    <div className="card flex-fill cursor-pointer">
                    <div className="card-body my-card-body">
                        <div className="d-flex align-items-center justify-content-between">
                        <div className="d-flex align-items-center">
                          <div>
                            <p className="fs-12 fw-medium mb-0 text-gray-5 mb-1">High-Risk Roles</p>
                            <h3 className="counter">{data?.highRiskCount || 0}</h3>    
                          </div>
                        </div>
                        </div>
                    </div>
                    </div>
                </div>
                <div className="col-xl-3 col-md-6 d-flex">
                    <div className="card flex-fill cursor-pointer">
                    <div className="card-body my-card-body">
                        <div className="d-flex align-items-center justify-content-between">
                        <div className="d-flex align-items-center">
                          <div>
                            <p className="fs-12 fw-medium mb-0 text-gray-5 mb-1">Collection Efficiency</p>
                            <h3 className="counter">{data?.collection_efficiency}%</h3>    
                          </div>
                        </div>
                        </div>
                    </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    
    </>
   );
}

export default Overview
